import type { DiligenceDocumentRun } from '../types';

/** The persisted run belongs to the execution; message.timestamp orders the conversation. */
export function getActivityStartTime(run: Partial<DiligenceDocumentRun> | undefined, fallback?: number) {
  if (typeof run?.startedAtMs === 'number' && Number.isFinite(run.startedAtMs) && run.startedAtMs >= 0) {
    return run.startedAtMs;
  }
  if (typeof run?.attemptStartedAtMs === 'number' && Number.isFinite(run.attemptStartedAtMs)
    && run.attemptStartedAtMs >= 0) return run.attemptStartedAtMs;
  return typeof fallback === 'number' && Number.isFinite(fallback) ? fallback : undefined;
}
